import { withInstall } from "../../utils/index"
import scImage from './components/index.vue'

export const ScImage = withInstall(scImage)